module.exports = __webpack_public_path__ + "static/media/client_services.0206edc8.jpg";